import { DiagnosticoData } from '../models/store.model';
import * as fromActions from '../actions/diagnostico.action';

export const diagnosticoInitialState: DiagnosticoData | null = null;

export function diagnosticoDataReducer(
    state = diagnosticoInitialState,
    action: fromActions.DiagnosticoDataActions
): DiagnosticoData | null {

    switch (action.type) {

        case fromActions.SETDIAGNOSTICODATA:
            return action.diagnostico;

        case fromActions.UNSETDIAGNOSTICODATA:
            return diagnosticoInitialState;

        default:
            return state;
    }
}
